import script from "./ConfirmDeleteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmDeleteModal.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmDeleteModal.vue?vue&type=style&index=0&id=372fb5b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-372fb5b8"]])

export default __exports__